import React from 'react'
import withView from '../cmn/docAutomation/withView';
import DocTagSelector from './DocTagSelector';
import FormTitle from "../../library/form/components/FormTitle";
import { UiView, UiViewHeading, UiTitle } from "../../library/layout/Index";

const DocTag = (props)=>{
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)
//acDepCtrl: { 'dparam': '%dataList:valLCat' },
    return(
        <UiView>
        <UiViewHeading>
            <UiTitle>
                <FormTitle formObject={formObject} value='Assign Tag' />
            </UiTitle>
        </UiViewHeading>
        <DocTagSelector formObject={formObject} viewData={viewData} />
    </UiView>
    )
}

export default withView(DocTag, "docTag", "docTag,docAttributeValue");
